import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class SendTest extends Performer<
  {
    payload: {
      chatterId: number
      testNumber: number
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/assessment/send'
}

export default new SendTest().perform
